export enum Vendor {
  Ipic = 'ipic'
}
